import { render, staticRenderFns } from "./DataDialog.vue?vue&type=template&id=10e87f17&"
import script from "./DataDialog.vue?vue&type=script&lang=js&"
export * from "./DataDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports